import { Image } from 'app/src/shared/components'
import tutorialImage from 'app/static/images/tutorial.png'
import { useTranslation } from 'react-i18next'

export function HowToSection() {
  const { t } = useTranslation('tutorial', { keyPrefix: 'Tutorial.HowToSection' })
  return (
    <div className='grid gap-4 p-4'>
      <div>
        <div className='text-[21px] font-bold leading-[31.5px]'>{t('Title')}</div>
      </div>
      <div className='grid pl-6 lg:grid-cols-12'>
        <div dangerouslySetInnerHTML={{ __html: t('Text') }} className='lg:col-span-9'></div>
        <div className='lg:col-span-3'>
          <Image src={tutorialImage} alt='Immagine per la sezione di tutorial' />
        </div>
      </div>
    </div>
  )
}
